var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgTs = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 128 128"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 120,
  height: 120,
  x: 4,
  y: 4,
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 7,
  rx: 5,
  ry: 5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M74.3 99.5v14c2.2 1.2 5 2 8 2.6a52.9 52.9 0 0 0 19.4 0c3-.7 5.6-1.8 8-3.2a16.2 16.2 0 0 0 7.3-14.7 15.6 15.6 0 0 0-4.4-11.8 24 24 0 0 0-5.1-4 55 55 0 0 0-6.8-3.3 84.8 84.8 0 0 1-8.7-4.4c-1-.8-1.8-1.6-2.3-2.4a5 5 0 0 1-.8-2.8c0-1 .2-1.8.7-2.6s1.2-1.5 2.1-2c.9-.6 2-1 3.3-1.3 1.3-.3 2.8-.5 4.4-.5a27.6 27.6 0 0 1 14.8 4.4v-13c-2-1-4.4-1.5-7-2a46.3 46.3 0 0 0-18 .6 24 24 0 0 0-7.9 3.3c-2.2 1.5-4 3.5-5.3 5.8a17 17 0 0 0-2 8.5c0 4.2 1.2 7.7 3.6 10.7 2.4 3 6 5.4 11 7.5l5.3 2.3c1.7.7 3.1 1.5 4.3 2.4s2.2 1.7 2.9 2.6a5.5 5.5 0 0 1 .4 5.8c-.4.8-1.1 1.5-2 2-.9.6-2 1-3.3 1.4a26.5 26.5 0 0 1-22-6zm-23.6-35H69V53H18v11.6h18.2V116h14.5z",
  clipRule: "evenodd"
})));

export default SvgTs;